import { render, staticRenderFns } from "./requesters-list.vue?vue&type=template&id=4a5287c3"
import script from "./requesters-list.vue?vue&type=script&lang=js"
export * from "./requesters-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports